import ENV from "../env";

const getStripeAccount = async (stripeId) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/stripe/account/${stripeId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error(
      resData?.error?.raw?.message || "Erreur inconnue lors de la récupération du compte Stripe",
    );
  }

  return resData;
};

export default getStripeAccount;
